var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVideoGray(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.752,
    height: 12.475,
    viewBox: "0 0 19.752 12.475",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_x37_7_Essential_Icons",
    transform: "translate(-12 -26)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Video_Camera",
    d: "M30.946,26.1l-4.392,2.833v-.858A2.085,2.085,0,0,0,24.475,26h-10.4A2.085,2.085,0,0,0,12,28.079V36.4a2.085,2.085,0,0,0,2.079,2.079h10.4A2.085,2.085,0,0,0,26.554,36.4v-.858l4.392,2.833a.531.531,0,0,0,.806-.442V26.52A.5.5,0,0,0,30.946,26.1ZM25.515,36.4a1.043,1.043,0,0,1-1.04,1.04h-10.4a1.043,1.043,0,0,1-1.04-1.04V28.079a1.043,1.043,0,0,1,1.04-1.04h10.4a1.043,1.043,0,0,1,1.04,1.04Zm5.2.6-4.158-2.677V30.158l4.158-2.677Z",
    fill: "#424242"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoGray);
export default __webpack_public_path__ + "static/media/video-gray.61cd8eeeaaf49dccdd9bfe0c65eb8483.svg";
export { ForwardRef as ReactComponent };